/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApplicationWithdrawRequest as ModelsV4ApplicationApplicationWithdrawRequest } from '../../models/Models/v4/Application/application-withdraw-request';
import { ApplicationWithdrawRequestBaseResponse as ModelsV4ApplicationApplicationWithdrawRequestBaseResponse } from '../../models/Models/v4/Application/application-withdraw-request-base-response';

export interface V4ApplicationVehicleApplicationIdWithdrawPost$Xml$Xml$Params {
  applicationId: string;
      body?: ModelsV4ApplicationApplicationWithdrawRequest
}

export function v4ApplicationVehicleApplicationIdWithdrawPost$Xml$Xml(http: HttpClient, rootUrl: string, params: V4ApplicationVehicleApplicationIdWithdrawPost$Xml$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV4ApplicationApplicationWithdrawRequestBaseResponse>> {
  const rb = new RequestBuilder(rootUrl, v4ApplicationVehicleApplicationIdWithdrawPost$Xml$Xml.PATH, 'post');
  if (params) {
    rb.path('applicationId', params.applicationId, {});
    rb.body(params.body, 'application/*+xml');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/xml', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelsV4ApplicationApplicationWithdrawRequestBaseResponse>;
    })
  );
}

v4ApplicationVehicleApplicationIdWithdrawPost$Xml$Xml.PATH = '/v4/application/vehicle/{applicationId}/withdraw';
